import React, {createContext, useCallback, useContext, useMemo, useState} from "react";
import {Alert, AlertTitle, List, ListItem, Snackbar} from "@mui/material";
import {SuccessIcon} from "./SvgIcons";

/**
 * @deprecated
 */
export function Notify() {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [state, setState] = React.useState({});

  /**
   * @param {type, msg, errors: string | Array, duration, positionH, positionV} props
   */
  const openNotify = (props) => {
    setState(props);

    setOpenSnackbar(false);
    setOpenSnackbar(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  return [(<div>
    <Snackbar
      anchorOrigin={{vertical: state.positionV || 'top', horizontal: state.positionH || 'right'}}
      open={openSnackbar} autoHideDuration={state.duration} onClose={handleClose}
    >
      <Alert
        icon={state.type === 'success' ? <SuccessIcon size={24} /> : void 0}
        onClose={handleClose}
        severity={state.type}
        variant="outlined"
        sx={{width: '100%', backgroundColor: '#ffffff', verticalAlign: 'middle', lineHeight: '40px'}}
      >
        <AlertTitle>{state.msg}</AlertTitle>
        {state?.errors ? <AlertErrorsList errors={state.errors} /> : void 0}
      </Alert>
    </Snackbar>
  </div>), openNotify]
}

const NotifyContext = createContext();

export const useNotify = () => {
  return useContext(NotifyContext);
};

export const NotifyProvider = ({ children }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [state, setState] = useState({});

  /**
   * @param {type, msg, errors: string | Array, duration, positionH, positionV} props
   */
  const openNotify = useCallback((props) => {
    setState(props);
    setOpenSnackbar(true);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const value = useMemo(() => ({ openNotify }), []);

  return (
    <NotifyContext.Provider value={value}>
      {children}
      <NotifyComponent
        open={openSnackbar}
        state={state}
        onClose={handleClose}
      />
    </NotifyContext.Provider>
  );
};

export const NotifyComponent = ({ open, state, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: state.positionV || 'top',
        horizontal: state.positionH || 'right'
      }}
      open={open}
      autoHideDuration={state.duration}
      onClose={onClose}
    >
      <Alert
        icon={state.type === 'success' ? <SuccessIcon size={24} /> : undefined}
        onClose={onClose}
        severity={state.type}
        variant="outlined"
        sx={{
          width: '100%',
          backgroundColor: '#ffffff',
          verticalAlign: 'middle',
          lineHeight: '40px'
        }}
      >
        <AlertTitle>{state.msg}</AlertTitle>
        {state?.errors ? (
          <AlertErrorsList errors={state.errors} />
        ) : null}
      </Alert>
    </Snackbar>
  );
};

export const AlertErrorsList = ({errors}) => {
  if(!errors?.length)
    return;

  if(!Array.isArray(errors)) {
    return <List>
      <ListItem>{errors}</ListItem>
    </List>
  }

  return (<List>
    {errors?.map((item) => {
      return (<ListItem style={{ lineHeight: 1, margin: 0, paddingLeft: 1 }}>{item.message}</ListItem>)
    })}
  </List>)
}
